import { useEffect } from "react";
import { OpenMessage, LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

type ItemLabelKey = "signals" | "trades" | "bots";

export const useRemoveDeselectedItems = (
  selectedIDs: number[],
  validIDsSet: Set<number>,
  onSelect: (ids: number[]) => void,
  itemLabel: ItemLabelKey,
  openMessage?: OpenMessage
) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);

  useEffect(() => {
    const validIDs = selectedIDs.filter((id) => validIDsSet.has(id));
    const numRemoved = selectedIDs.length - validIDs.length;
    if (numRemoved > 0) {
      onSelect(validIDs);
      openMessage?.(
        t("bulk_actions.removed_from_selection", {
          count: numRemoved,
          itemLabel: t(`bulk_actions.item_labels.${itemLabel}`),
        }),
        "warning"
      );
    }
  }, [validIDsSet]);
};
